import { useMemo } from 'react';
import { CandidatesConst } from '@axiom/const';
import { candidateOpportunityStatusUtils } from '@axiom/utils';
import type {
  BaseCandidateOpportunity,
  Opportunity,
  OpportunityPosition,
  User,
} from '@axiom/validation';

export const useCanDoInterviewEvents = ({
  opportunity,
  position,
  user,
  opportunityCandidateStatus,
}: {
  opportunity?: Opportunity;
  position?: OpportunityPosition;
  user: User;
  opportunityCandidateStatus?: BaseCandidateOpportunity['candidateStatus'];
}): boolean => {
  return useMemo(() => {
    if (!opportunity?.isQualificationComplete) {
      return false;
    }
    return (
      opportunityCandidateStatus ===
        CandidatesConst.CandidateStatuses.Interviewing ||
      !!(
        opportunityCandidateStatus &&
        candidateOpportunityStatusUtils.isValidTransition({
          currentCandidateStatus: opportunityCandidateStatus,
          opportunity,
          position,
          role: user.roles[0],
          targetStatus: CandidatesConst.CandidateStatuses.Interviewing,
        })
      )
    );
  }, [opportunity, position, user, opportunityCandidateStatus]);
};
